import React from 'react';

import { Abstrap, ButtonContainer } from '../..';

const { propTypes } = Abstrap;

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    title: '',
};

class TabMenuButtonContainer extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-tab-menu__btn',
            className,
        ];
    }

    renderChildren() {
        const { children } = this.props;
        return (
            <ButtonContainer>
                {children}
            </ButtonContainer>
        );
    }

}

TabMenuButtonContainer.propTypes = propTypes;

TabMenuButtonContainer.defaultProps = defaultProps;

export default TabMenuButtonContainer;
